import TYPES from '../types';

export default payload => {
  return {
    type: TYPES.SET_INSTRUCTOR_SESSION,
    payload,
  };
};
